import * as _ from 'lodash';
import * as planAheadAPI from '@/api/PlanAheadApi';

const state = {
  plans: [],
  calculatedMonthlyAmount: null,
  currentPlan: {},
  showPlansInSection: false,
  suggestions: [],
};

const getters = {
  plans: state => state.plans,
  hasPlans: state => state.plans.length > 0,
  totalPlansMonthlyAmount: state => _.sumBy(state.plans, plan => plan.monthlyTarget) || 0,
};

const actions = {
  async initPlans({ commit }) {
    const plans = await planAheadAPI.getPlans();
    await commit('setPlans', plans);
  },
  async initPlansSuggestions({ commit }) {
    const suggestions = await planAheadAPI.getSuggestions();
    await commit('setSuggestions', suggestions);
  },
  async addPlan({ commit, state, dispatch }) {
    const plan = await planAheadAPI.createPlan(state.currentPlan);
    await commit('addPlan', plan);
  },
  async addPlanTransaction({ commit, state }, planTransaction) {
    await planAheadAPI.addPlanTransaction(planTransaction);
  },
  async deletePlan({ commit, state, dispatch }, plan) {
    await planAheadAPI.deletePlan(plan._id);
    await commit('deletePlan', plan._id);
  },
  async updatePlan({ commit, state, dispatch }) {
    const planMetadata = _.pick(state.currentPlan, ['name', 'type', 'targetAmount', 'deadline']);
    await planAheadAPI.updatePlan(state.currentPlan._id, planMetadata);
    await dispatch('initPlans');
  },
  async pausePlan({ commit, state, dispatch }, plan) {
    const updatedPlan = await planAheadAPI.pausePlan(plan._id);
    await commit('updatePlan', updatedPlan);
  },
  async resumePlan({ commit, state, dispatch }, plan) {
    const updatedPlan = await planAheadAPI.resumePlan(plan._id);
    await commit('updatePlan', updatedPlan);
  },
  async completePlan({ commit, state, dispatch }, plan) {
    const updatedPlan = await planAheadAPI.completePlan(plan._id);
    await commit('updatePlan', updatedPlan);
  },
  async getCalculatedMonthlyAmount({ commit }, { deadline, targetAmount }) {
    const { calculatedMonthlyAmount } = await planAheadAPI.calculatedMonthlyAmount(deadline, targetAmount);
    await commit('setCalculatedMonthlyAmount', calculatedMonthlyAmount);
  },
  async updateCurrentPlan({ commit }, prop) {
    await commit('updateCurrentPlan', prop);
  },
  async resetCurrentPlan({ commit }) {
    await commit('resetCurrentPlan');
  },
};

const mutations = {
  setPlans(state, plans) {
    state.plans = plans;
  },
  setSuggestions(state, suggestions) {
    state.suggestions = suggestions;
  },
  setShowPlansInSection(state, value) {
    state.showPlansInSection = value;
  },
  addPlan(state, plan) {
    state.plans.push(plan);
    state.showPlansInSection = true;
  },
  deletePlan(state, planId) {
    const index = _.findIndex(state.plans, plan => plan._id === planId);
    state.plans.splice(index, 1);
  },
  updatePlan(state, updatedPlan) {
    const index = _.findIndex(state.plans, plan => plan._id === updatedPlan._id);
    state.plans.splice(index, 1, updatedPlan);
    state.showPlansInSection = true;
  },
  setCalculatedMonthlyAmount(state, calculatedMonthlyAmount) {
    state.calculatedMonthlyAmount = calculatedMonthlyAmount;
  },
  updateCurrentPlan(state, prop) {
    state.currentPlan = { ...state.currentPlan, ...prop };
  },
  resetCurrentPlan(state) {
    state.currentPlan = {};
    state.calculatedMonthlyAmount = null;
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
